
import React from 'react'
import Gaurd from 'Util/Guard';
import { PageRoutes } from './Config'
import { Route, Routes } from "react-router";
import PageNotFound from "Pages/PageNotFound/pageNotFound"
import AccessDenied from "Pages/AccessDenied/denied"
import Login from 'Pages/Login/Login'
import useStore from 'Store';
import LayoutClasses from 'Components/Layout/Layout.module.css'
import SideNav from 'Components/Layout/SideNav/Navbar';
const Router = () => {
  const showNav = useStore((state) => state.showNavbar);
  const setShowNav = useStore((state) => state.setshowNavbar);
  const setActiveTab = useStore((State) => State.setActiveTab);
  const ActiveTab = useStore((State) => State.ActiveTab);

  const PageData = PageRoutes.map(({ path, element, AccessKey, Type }) => {
    return <Route path={path} key={AccessKey} element={<Gaurd Type={Type} element={element} permissions={AccessKey} key={AccessKey} />} />

  })

  PageData.push(

    <Route key="forbidden" path="/forbidden" element={<AccessDenied />} />,
    // <Route key="notfound" path="*" element={<PageNotFound />} />
  );

  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
      </Routes>
      <div className={LayoutClasses["Wrapper"]}>
        <SideNav Active={ActiveTab} setShow={setShowNav} show={showNav} />
        <Routes>

          {PageData}
        </Routes>

      </div>
    </>
  )
}

export default Router